const ja = {
  // Header
  nav_home: 'ホーム',
  nav_booking: '予約する',
  nav_therapists: 'セラピスト',
  menu_label: 'メニュー',

  // Hero
  hero_badge: 'Premium Thai Massage',
  hero_title: 'タイ最高の\nマッサージを体験',
  hero_subtitle: 'パタヤ、プーケット、バンコク、コラートでプロのセラピストによるプレミアムマッサージをご予約ください',
  hero_book_now: '今すぐ予約',
  hero_view_therapists: 'セラピスト一覧',
  stat_therapists: '専門セラピスト',
  stat_locations: 'エリア',
  stat_rating: '平均評価',

  // Features
  feature_gps_title: 'GPS自動検出',
  feature_gps_desc: '現在地から最寄りのエリアを自動的に検出します',
  feature_booking_title: '簡単予約',
  feature_booking_desc: '5ステップで簡単にマッサージを予約',
  feature_verified_title: '認定セラピスト',
  feature_verified_desc: '経験と口コミで検証された専門セラピスト',

  // Nearby therapists section
  nearby_title: 'お近くのセラピスト',
  nearby_subtitle: 'GPS位置情報に基づいて最寄りのセラピストをおすすめします',
  nearby_loading: '位置を検出しています...',
  nearby_error: '位置を検出できません',
  nearby_retry: '再試行',
  nearby_distance: '{distance}km先',
  nearby_book: '予約する',

  // Locations section
  section_locations_title: '予約可能エリア',
  section_locations_subtitle: 'タイの主要5都市でサービスを提供しています',
  loc_book: '予約する',

  // Courses section
  section_courses_title: 'マッサージコース',
  section_courses_subtitle: '様々なマッサージプログラムをご覧ください',

  // Therapists section
  section_therapists_title: '人気セラピスト',
  section_therapists_subtitle: 'トップ評価のセラピストをご紹介します',
  view_all_therapists: '全セラピストを見る',

  // CTA
  cta_title: '今すぐご予約ください',
  cta_subtitle: '最高のタイマッサージ体験がお待ちしています',
  cta_book: '予約する',

  // Footer
  footer_copyright: '© 2026 Thai Massage Booking. All rights reserved.',

  // Booking Steps
  step_location: 'エリア選択',
  step_course: 'コース選択',
  step_therapist: 'セラピスト',
  step_datetime: '日時',
  step_confirm: '確認',

  // Booking - Step 1
  booking_location_title: 'エリアを選択してください',
  booking_location_desc: 'マッサージを受けるエリアを選択してください',
  gps_detect: '現在地から自動検出',
  gps_loading: '位置を検出中...',

  // Booking - Step 2
  booking_course_title: 'マッサージコースを選択してください',
  booking_course_desc: 'ご希望のマッサージの種類と時間を選択してください',
  duration_min: '{min}分',

  // Booking - Step 3
  booking_therapist_title: 'セラピストを選択してください',
  booking_therapist_desc: '{location}で活動するセラピストです',
  no_therapist: '選択したエリアとコースに合うセラピストがいません。',
  no_therapist_suggest: '別のコースをお選びください。',

  // Booking - Step 4
  booking_datetime_title: '日時を選択してください',
  booking_datetime_desc: 'ご希望の日付と時間を選択してください',
  date_select: '日付選択',
  time_select: '時間選択',
  time_placeholder: '先に日付を選択してください',
  time_notice: '距離により到着まで最大2時間かかる場合があります。余裕のある時間をお選びください。',

  // Booking - Step 5
  booking_confirm_title: '予約情報をご確認ください',
  booking_confirm_desc: 'すべての情報を確認し、連絡先を入力してください',
  summary_location: 'エリア',
  summary_course: 'コース',
  summary_price: '料金',
  summary_therapist: 'セラピスト',
  summary_date: '日付',
  summary_time: '時間',
  health_check_title: '健康状態の確認',
  health_check_desc: '健康状態や痛みのある部位、マッサージを避けたい部位があればお知らせください。',
  health_check_placeholder: '例：高血圧があります / 右肩を痛めたので上半身は軽めにお願いします / 腰のヘルニアがあるので腰は避けてください',
  health_check_examples: '例：高血圧があります / 右肩を痛めたので上半身は軽めにお願いします / 腰のヘルニアがあるので腰は避けてください',
  contact_title: '連絡先情報',
  contact_name: 'お名前',
  contact_name_placeholder: 'お名前を入力してください',
  contact_phone: '電話番号',
  contact_phone_placeholder: '電話番号を入力してください',
  contact_email: 'メールアドレス',
  contact_email_placeholder: 'メールアドレスを入力してください',
  contact_note: 'ご要望',
  contact_note_placeholder: '特別なご要望があればご入力ください',
  required_mark: '*',

  // Navigation buttons
  btn_prev: '戻る',
  btn_next: '次へ',
  btn_complete: '予約完了',

  // Therapist card
  age_suffix: '歳',
  experience_years: '経験{years}年',

  // Therapist list page
  tl_title: 'セラピスト',
  tl_subtitle: '経験と専門性で検証された最高のセラピストに出会いましょう',
  tab_all: '全員',

  // Confirmation page
  conf_empty_title: '予約情報がありません',
  conf_empty_desc: '予約ページから予約を進めてください。',
  conf_empty_btn: '予約する',
  conf_success_title: '予約が完了しました！',
  conf_success_subtitle: '予約情報が確認されました。ありがとうございます。',
  conf_preparation_title: 'ご予約を受け付けておりません',
  conf_preparation_subtitle: '現在サービス準備中のため、ご予約はまだ確定していません。正式オープン後にご連絡いたします。',
  conf_preparation_notice: 'サービス準備中につき、本予約は確定予約ではありません。',
  conf_booking_id: '予約番号',
  conf_detail_title: '予約詳細',
  conf_label_location: 'エリア',
  conf_label_course: 'マッサージコース',
  conf_label_price: '料金',
  conf_label_therapist: 'セラピスト',
  conf_label_date: '日付',
  conf_label_time: '時間',
  conf_label_email: 'メールアドレス',
  conf_label_contact: '連絡先',
  conf_label_note: 'ご要望',
  conf_notice_title: 'ご案内',
  conf_notice_1: '距離により到着まで最大2時間かかる場合があります。',
  conf_notice_2: '予約の変更・キャンセルはお電話でお問い合わせください。',
  conf_notice_3: '現場で現金またはカードでお支払いいただけます。',
  conf_btn_home: 'ホームへ',
  conf_btn_new: '新規予約',

  // Geolocation errors
  GEO_NOT_SUPPORTED: 'お使いのブラウザはGPSに対応していません。',
  GEO_PERMISSION_DENIED: '位置情報へのアクセスが拒否されました。手動でエリアを選択してください。',
  GEO_POSITION_UNAVAILABLE: '位置情報を取得できません。',
  GEO_TIMEOUT: '位置情報のリクエストがタイムアウトしました。',
  GEO_UNKNOWN: '不明なエラーが発生しました。',

  // SEO
  seo_home_title: 'バンコク出張マッサージ予約 | Bangkok In Home Massage',
  seo_home_desc: 'バンコク、パタヤ、プーケット、チェンマイ、コラートのホテル・宿泊先へ認定セラピストが訪問。タイ古式、アロマ、オイルマッサージをオンラインで簡単予約できます。',
  seo_therapists_title: '出張マッサージセラピスト | Bangkok In Home Massage',
  seo_therapists_desc: 'バンコク、パタヤ、プーケット、チェンマイ、コラートの認定セラピスト。プロフィール、評価、専門分野を確認して今すぐご予約いただけます。',
  seo_booking_title: '出張マッサージ オンライン予約 | Bangkok In Home Massage',
  seo_booking_desc: '地域・コース・セラピストを選んで、ご希望の日時に出張マッサージをご予約ください。ホテルや宿泊先へセラピストがお伺いします。',

  // Body info
  height_label: '身長',
  weight_label: '体重',

  // GPS therapist list
  gps_find_nearby: '近くのセラピストを探す',
  gps_nearby_active: '近い順に表示中',

  // Notices
  notice_punctual: 'セラピストはご予約の日時に合わせてお伺いします。時間通りにご準備ください。',
  notice_no_sexual: '本サービスは専門的なマッサージサービスです。性的なサービスは一切提供しておりません。',

  // Guide section
  guide_title: 'ご利用案内',
  guide_subtitle: '快適なサービスのため、以下のご案内をご確認ください',
  guide_before_title: '施術前のご案内',
  guide_before_text: '施術前に軽いシャワーをお勧めします。食後すぐのご利用はお控えください。飲酒状態では施術をお断りする場合があります。持病（高血圧、心臓疾患など）がある方や妊娠中の方は、ご予約時にご要望欄にご記入ください。',
  guide_booking_title: 'ご予約案内',
  guide_booking_text: '距離により到着まで最大2時間かかる場合があります。余裕のある時間をお選びください。予約の変更・キャンセルはお電話でお問い合わせください。',
  guide_session_title: '施術中のご案内',
  guide_session_text: 'セラピストがご予約の時間に合わせて宿泊先へお伺いします。施術中に不快な点がございましたら、すぐにお申し付けください。本サービスは専門的なマッサージサービスです。性的なサービスは一切提供しておりません。',
  guide_after_title: '施術後のご案内',
  guide_after_text: '十分な水分補給をお願いします。一時的な筋肉痛や疲労感は正常な反応で、2〜3日で回復します。当日の過度な飲酒や激しい運動はお控えください。',
  guide_payment_title: 'お支払い案内',
  guide_payment_text: '現場で現金またはカードでお支払いいただけます。',

  // FAQ
  faq_q1: '出張マッサージはどのように利用しますか？',
  faq_a1: 'エリアを選択し、マッサージの種類を選び、セラピストを選んで日時を予約してください。セラピストがホテルや宿泊先にお伺いします。',
  faq_q2: 'どのエリアでサービスを利用できますか？',
  faq_a2: 'バンコク、パタヤ、プーケット、チェンマイ、コラートの5エリアで専門的な出張マッサージサービスを提供しています。',
  faq_q3: '予約の変更やキャンセルはどうすればいいですか？',
  faq_a3: '予約の変更・キャンセルはお電話でお問い合わせください。お支払いは現場で現金またはカードで可能です。',

  // 404
  notfound_title: 'ページが見つかりません',
  notfound_desc: 'お探しのページは存在しないか、移動されました。',
  notfound_home: 'ホームに戻る',
};

export default ja;
